export const buttonsGrid12 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  p: "16px 25px !important",
  boxShadow: "0px -3px 24px rgba(0, 0, 0, 0.12)",
};

export const titleGrid12 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: "32px 25px !important",
};

export const stickyToTop = {
  position: "sticky",
  top: 0,
  backgroundColor: "#fff",
  zIndex: 1000,
};

export const stickyToBottom = {
  position: "sticky",
  bottom: 0,
  backgroundColor: "#fff",
  zIndex: 1000,
};

export const divider = {
  margin: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: "#eeeeee",
  borderBottomWidth: "thin",
  opacity: 1,
};
